// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "fb6718a5f35d5b28f7f9" + ".chunk.js";
};